import { PoolOperation } from './pool';
export class SumOperation extends PoolOperation {
    update(a, b) {
        return `${a} + ${b}`;
    }
}
//# sourceMappingURL=sum.js.map